export default __webpack_public_path__ + "static/media/IMG_6725.576e012d.jpeg";